import axios from 'axios'
import { getRegionFromLocationId } from '../app/selectors'

const endpoint = process.env.REACT_APP_DATA_ENDPOINT + '/similar'

export const fetchSimilarLocationsCsv = (region, stateId) => {
  const filename = stateId + '.csv'
  return axios(`${endpoint}/${region}/${filename}?v=2`)
}

export const parseSimilarLocationsFromCsv = (result, locationId) => {
   // regex to grab the line that matches the feature ID
  const matcher = new RegExp(`^${locationId},.*\n`, 'gm')
  const matched = result.data.match(matcher)
  const otherIds = matched ?
    matched[0]
      .slice(0, -1)
      .split(',')
      .filter(id => id !== locationId && !!getRegionFromLocationId(id))
  : []
  return otherIds
}

export const fetchSimilarLocations = locationId => {
  const region = getRegionFromLocationId(locationId)
  const stateId = locationId.substring(0, 2)
  return fetchSimilarLocationsCsv(region, stateId).then(
    result => parseSimilarLocationsFromCsv(result, locationId)
  )
}